/* Captura · Lista VIP — envia o lead ao ActiveCampaign (mesmo endpoint do formulário embutido),
   dispara o evento Lead e redireciona para o link do grupo (DevZapp). */
(function () {
  'use strict';
  var raiz = document.querySelector('.cv[data-link]');
  if (!raiz) return;
  var form = raiz.querySelector('[data-cv-form]');
  var btn = raiz.querySelector('[data-cv-btn]');
  var erroEl = raiz.querySelector('[data-cv-erro]');
  var sucesso = raiz.querySelector('[data-cv-sucesso]');
  var linkEl = raiz.querySelector('[data-cv-link]');
  var barra = raiz.querySelector('[data-cv-barra]');
  var LINK = (raiz.getAttribute('data-link') || '').trim();
  var AC = {
    u: raiz.getAttribute('data-ac-u') || '7',
    f: raiz.getAttribute('data-ac-f') || '7',
    or: raiz.getAttribute('data-ac-or') || '',
    campo: (raiz.getAttribute('data-ac-campo') || '').replace(/\D/g, ''),
    sms: raiz.getAttribute('data-ac-sms') !== 'false'
  };
  var LEAD = raiz.getAttribute('data-lead') !== 'false';
  var PAINEL = (raiz.getAttribute('data-painel') || '').trim();
  var SHEETS = (raiz.getAttribute('data-sheets') || '').trim();
  var ENDPOINT = 'https://berzerkmkt.activehosted.com/proc.php';
  var CHAVE = 'bzk_vip_black';
  var finalizado = false;

  /* ---------- utilidades ---------- */
  function digitos(v) { return (v || '').replace(/\D/g, ''); }
  function mascaraTel(v) {
    var d = digitos(v).slice(0, 11);
    if (d.length <= 2) return d.length ? '(' + d : '';
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }
  function emailOk(v) { return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v || ''); }
  function telOk(v) { var d = digitos(v); return d.length === 10 || d.length === 11; }
  function mostrarErro(msg) { if (!erroEl) return; erroEl.textContent = msg; erroEl.hidden = !msg; }
  function marcar(el, ruim) { if (el) el.classList.toggle('cv-invalido', !!ruim); }
  function lerSalvo() { try { return JSON.parse(localStorage.getItem(CHAVE) || 'null'); } catch (e) { return null; }
  }
  function salvar(obj) { try { localStorage.setItem(CHAVE, JSON.stringify(obj)); } catch (e) {} }

  /* ---------- máscara de telefone ---------- */
  var tel = form && form.querySelector('input[name="phone"]');
  if (tel) {
    tel.addEventListener('input', function () { tel.value = mascaraTel(tel.value); });
  }
  form && form.querySelectorAll('input, select').forEach(function (el) {
    el.addEventListener('input', function () { marcar(el, false); mostrarErro(''); });
    el.addEventListener('change', function () { marcar(el, false); mostrarErro(''); });
  });

  /* ---------- eventos de lead ---------- */
  function dispararLead(dados) {
    if (!LEAD) return;
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'lista-vip-black', content_category: dados.interesse || '' }); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'bzk_lead', lista: 'vip-black', interesse: dados.interesse || '' }); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('bzk_lead', { lista: 'vip-black', interesse: dados.interesse || '' }); } catch (e) {}
  }

  /* ---------- cópias do lead (painel Berzerk e planilha Google), sem travar o cliente ---------- */
  function uuid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'l-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function montarCopia(dados, origem) {
    var q = {};
    try { new URLSearchParams(location.search).forEach(function (v, k) { q[k] = v; }); } catch (e) {}
    var dig = digitos(dados.phone);
    var ddd = dig.slice(0, 2);
    var agora = new Date();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tz = -agora.getTimezoneOffset();
    var iso = agora.getFullYear() + '-' + pad(agora.getMonth() + 1) + '-' + pad(agora.getDate()) + 'T' + pad(agora.getHours()) + ':' + pad(agora.getMinutes()) + ':' + pad(agora.getSeconds()) + (tz >= 0 ? '+' : '-') + pad(Math.floor(Math.abs(tz) / 60)) + ':' + pad(Math.abs(tz) % 60);
    return {
      id: dados.id, data_hora: iso, nome: dados.fullname, primeiro_nome: (dados.fullname || '').split(' ')[0],
      telefone: dig ? '55' + dig : '', telefone_formatado: dados.phone, ddd: ddd, email: dados.email,
      interesse: dados.interesse || '', consentimento: AC.sms ? 'sim' : 'nao', origem_envio: origem,
      utm_source: q.utm_source || '', utm_medium: q.utm_medium || '', utm_campaign: q.utm_campaign || '',
      utm_content: q.utm_content || '', utm_term: q.utm_term || '',
      pagina: location.href.split('?')[0], referrer: document.referrer || '',
      dispositivo: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'celular' : 'computador',
      grupo_link: LINK
    };
  }
  function enviarCopias(dados, origem) {
    var corpo;
    try { corpo = JSON.stringify(montarCopia(dados, origem)); } catch (e) { return; }
    [PAINEL, SHEETS].forEach(function (url) {
      if (!url) return;
      try {
        fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: corpo }).catch(function () {});
      } catch (e) {}
    });
  }

  /* ---------- conclusão (sucesso, erro ou tempo esgotado) ---------- */
  function concluir(dados, origem) {
    if (finalizado) return;
    finalizado = true;
    salvar({ nome: dados.fullname, email: dados.email, interesse: dados.interesse, quando: Date.now(), origem: origem });
    enviarCopias(dados, origem);
    dispararLead(dados);
    if (LINK) {
      setTimeout(function () { window.location.href = LINK; }, 400);
      setTimeout(mostrarSucesso, 1800);
    } else {
      mostrarSucesso();
    }
  }
  function mostrarSucesso() {
    if (!sucesso) return;
    if (form) form.hidden = true;
    if (linkEl) {
      if (LINK) { linkEl.href = LINK; linkEl.hidden = false; } else { linkEl.hidden = true; }
    }
    sucesso.hidden = false;
    if (barra) barra.hidden = true;
    try { sucesso.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }

  /* Ganchos que o ActiveCampaign chama na resposta JSONP. */
  var pendente = null;
  window._show_thank_you = function () { if (pendente) concluir(pendente, 'ac'); };
  window._show_pc_confirmation = function () { if (pendente) concluir(pendente, 'ac'); };
  window._show_error = function (id, msg) {
    if (!pendente) return;
    /* e-mail inválido para o AC: devolve o erro ao cliente; qualquer outro erro não trava o lead */
    if (/e-?mail|email/i.test(msg || '') && !finalizado) {
      var email = form.querySelector('input[name="email"]');
      marcar(email, true);
      mostrarErro('Confira o e-mail digitado.');
      btn.disabled = false; btn.classList.remove('cv-enviando');
      pendente = null;
      return;
    }
    concluir(pendente, 'ac-erro');
  };
  window._load_script = function () {};

  function enviarAC(dados) {
    var p = [];
    function add(k, v) { p.push(encodeURIComponent(k) + '=' + encodeURIComponent(v == null ? '' : v)); }
    add('u', AC.u); add('f', AC.f); add('s', ''); add('c', '0'); add('m', '0'); add('act', 'sub'); add('v', '2'); add('or', AC.or);
    add('fullname', dados.fullname);
    add('email', dados.email);
    add('phone', '+55 ' + digitos(dados.phone));
    if (AC.sms) add('sms_consent', 'on');
    if (AC.campo && dados.interesse) add('field[' + AC.campo + ']', dados.interesse);
    add('jsonp', 'true');
    var sc = document.createElement('script');
    sc.src = ENDPOINT + '?' + p.join('&');
    sc.async = true;
    sc.onerror = function () { concluir(dados, 'ac-falha'); };
    document.head.appendChild(sc);
  }

  /* ---------- envio ---------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var nome = form.querySelector('input[name="fullname"]');
      var email = form.querySelector('input[name="email"]');
      var inter = form.querySelector('select[name="interesse"]');
      var consent = form.querySelector('input[name="sms_consent"]');
      var dados = {
        id: uuid(),
        fullname: (nome.value || '').trim(),
        phone: tel ? tel.value : '',
        email: (email.value || '').trim().toLowerCase(),
        interesse: inter ? inter.value : ''
      };
      var ruim = [];
      if (dados.fullname.length < 2) { marcar(nome, true); ruim.push('nome'); }
      if (!telOk(dados.phone)) { marcar(tel, true); ruim.push('WhatsApp com DDD'); }
      if (!emailOk(dados.email)) { marcar(email, true); ruim.push('e-mail'); }
      if (inter && !inter.value) { marcar(inter, true); ruim.push('o que você está de olho'); }
      if (ruim.length) {
        mostrarErro('Confira: ' + ruim.join(', ') + '.');
        var primeiro = form.querySelector('.cv-invalido');
        if (primeiro) primeiro.focus();
        return;
      }
      if (consent && !consent.checked) AC.sms = false;
      mostrarErro('');
      btn.disabled = true; btn.classList.add('cv-enviando');
      pendente = dados;
      enviarAC(dados);
      /* o cliente nunca fica preso esperando o CRM */
      setTimeout(function () { if (pendente && !finalizado) concluir(pendente, 'tempo'); }, 3500);
    });
  }

  /* ---------- já cadastrado nesta máquina ---------- */
  var salvo = lerSalvo();
  if (salvo && LINK && linkEl && sucesso) {
    var titulo = sucesso.querySelector('.cv-sucesso-titulo');
    if (titulo && salvo.nome) titulo.textContent = 'Você já está na lista, ' + salvo.nome.split(' ')[0] + '!';
    var txt = sucesso.querySelector('.cv-sucesso-texto');
    if (txt) txt.textContent = 'Entre no grupo VIP para receber os avisos. Quer cadastrar outra pessoa? ';
    var novo = document.createElement('a');
    novo.href = '#'; novo.textContent = 'Cadastrar de novo'; novo.style.cssText = 'color:#111;font-weight:700';
    novo.addEventListener('click', function (e) { e.preventDefault(); sucesso.hidden = true; if (form) form.hidden = false; if (barra) barra.hidden = false; });
    txt && txt.appendChild(novo);
    finalizado = false;
    mostrarSucesso();
  }

  /* ---------- rolagem até o formulário ---------- */
  raiz.querySelectorAll('[data-cv-ir]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var alvo = form && !form.hidden ? form : sucesso;
      try { alvo.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) { alvo.scrollIntoView(); }
      var primeiro = form && !form.hidden && form.querySelector('input[name="fullname"]');
      if (primeiro) setTimeout(function () { primeiro.focus({ preventScroll: true }); }, 500);
    });
  });

  /* ---------- barra fixa no mobile (aparece depois que o formulário sai da tela) ---------- */
  if (barra && form && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var visivel = entries[0].isIntersecting;
      barra.hidden = visivel || form.hidden;
    }, { threshold: 0.05 });
    io.observe(form);
  }

  /* ---------- contagem regressiva ---------- */
  var box = raiz.querySelector('[data-contagem-box]');
  var alvoIso = raiz.getAttribute('data-contagem');
  if (box && alvoIso) {
    var fim = Date.parse(alvoIso);
    if (!isNaN(fim)) {
      var d = box.querySelector('[data-ct="d"]'), h = box.querySelector('[data-ct="h"]'), m = box.querySelector('[data-ct="m"]'), sg = box.querySelector('[data-ct="s"]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var dif = Math.max(0, fim - Date.now());
        var seg = Math.floor(dif / 1000);
        d.textContent = pad(Math.floor(seg / 86400));
        h.textContent = pad(Math.floor(seg % 86400 / 3600));
        m.textContent = pad(Math.floor(seg % 3600 / 60));
        sg.textContent = pad(seg % 60);
        if (dif <= 0) { box.hidden = true; return; }
        box.hidden = false;
      }
      tick();
      setInterval(tick, 1000);
    }
  }
})();
